import * as React from "react";
import { Select } from "antd";
const Option = Select.Option;
import { connect } from "react-redux";

interface ICityProps {
  width?: number;
  getArea?: any;
  share?: any;
  // 选择的值
  value?: any;
  style?: React.CSSProperties;
  // 自定义字段，映射viewModel的字段
  "data-field"?: any;
  "area-field"?: any;
  modelName?: any;
  onChange?: any;
  // 重置区域
  resetArea?: any;
  setValue?: any;
  isLoadArea?: any;
}

class City extends React.Component<ICityProps, any> {
  constructor(props: ICityProps) {
    super(props);
    if (this.props.value && this.props.isLoadArea) {
      this.props.getArea(this.props.value);
    }
  }

  onChangeCity = e => {
    // 重置区域数据
    this.props.resetArea();

    // 重置城区域选择项
    let data = { model: this.props.modelName, formInfo: {} };
    data.formInfo[this.props["area-field"]] = "";
    this.props.setValue(data);

    // 加载区域信息
    if (this.props.isLoadArea) {
      this.props.getArea(e);
    }

    this.props.onChange(e, this.props["data-field"]);
  };

  render() {
    const list = this.props.share.city;
    const mapList = () => {
      let options: any = [];
      for (const item of list) {
        options.push(
          <Option key={item.id} value={item.id}>
            {item.name}
          </Option>
        );
      }
      return options;
    };

    // 当数据已加载完成时才设置选中的值
    const value = this.props.share.city.length
      ? this.props.value || undefined
      : undefined;

    // 根据关键字检索option
    const filter = (input, option) =>
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

    return (
      <Select
        style={{ width: this.props.width || 200 }}
        // this.props.value 不能为空
        value={value}
        // 显示一个x，可以清除当前选择的数据
        allowClear={true}
        placeholder="选择城市"
        onChange={this.onChangeCity}
        // 检索相关
        showSearch
        optionFilterProp="children"
        filterOption={filter}
        // 检索相关
      >
        {mapList()}
      </Select>
    );
  }
}

const mapState = state => ({
  share: state.share
});

const mapDispatch = dispatch => {
  return {
    getArea: dispatch.region.getArea,
    resetArea: dispatch.share.resetArea,
    setValue: dispatch.antDemo.setValue
  };
};

export default connect(
  mapState,
  mapDispatch
)(City);
